/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * SystemOverrideTarget defines which workload optimization features are affected by the system override.   - SYSTEM_OVERRIDE_TARGET_ALL: Affects all system overrides properties.  - SYSTEM_OVERRIDE_TARGET_VERTICAL_OPTIMIZATION: Affects only vertical optimization (resource recommendations).
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1SystemOverrideTarget = {
    UNSPECIFIED: 'SYSTEM_OVERRIDE_TARGET_UNSPECIFIED',
    ALL: 'SYSTEM_OVERRIDE_TARGET_ALL',
    VERTICAL_OPTIMIZATION: 'SYSTEM_OVERRIDE_TARGET_VERTICAL_OPTIMIZATION'
} as const;

export type WorkloadoptimizationV1SystemOverrideTarget = typeof WorkloadoptimizationV1SystemOverrideTarget[keyof typeof WorkloadoptimizationV1SystemOverrideTarget];



